import React, { type ReactNode, type ComponentType } from 'react';
import { Text, Stack } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';
import { fg } from '@atlassian/jira-feature-gating';
import { useIntl } from '@atlassian/jira-intl';
import { JiraSpotlight } from '@atlassian/jira-spotlight/src/ui/jira-spotlight.tsx';
import { messages } from './messages.tsx';

type SpotlightProps = typeof JiraSpotlight extends ComponentType<infer TProps> ? TProps : unknown;

interface Props {
	target: string;
	actionsBeforeElement: ReactNode;
	headingAfterElement: ReactNode;
	actions: (arg0: { learnMoreURL: string }) => SpotlightProps['actions'];
}

export const SaveYourChangesSpotlight = ({
	target,
	actionsBeforeElement,
	headingAfterElement,
	actions,
}: Props) => {
	const { formatMessage } = useIntl();
	return (
		<JiraSpotlight
			target={target}
			targetBgColor={token('elevation.surface')}
			targetRadius={3}
			heading={formatMessage(messages.heading)}
			actionsBeforeElement={actionsBeforeElement}
			dialogPlacement="bottom right"
			actions={actions({
				learnMoreURL:
					'https://support.atlassian.com/jira-software-cloud/docs/save-changes-made-in-advanced-roadmaps/',
			})}
			headingAfterElement={headingAfterElement}
			messageId="portfolio-3-onboarding.ui.onboarding.spotlight-save-your-changes.jira-spotlight"
			messageType="transactional"
		>
			<Stack space="space.100">
				<Text>
					{formatMessage(
						fg('jira-issue-terminology-refresh-m3')
							? messages.spotlightBodyIssueTermRefresh
							: messages.spotlightBody,
						{
							b: (chunks: ReactNode[]) => <Text weight="bold">{chunks}</Text>,
						},
					)}
				</Text>
			</Stack>
		</JiraSpotlight>
	);
};
